import { keyframes } from 'styled-components';

export const SPIN_TIMING = '3s cubic-bezier(0.26, 0.98, 0.67, 0.23) infinite';

export const spin = keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  `;
